import { CODE, TRANSFORMERS } from "@lexical/markdown";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin.js";
import React__default from "react";
import { CodeBlockNode, $createCodeBlockNode } from "../codeblock/CodeBlockNode.js";
import { coreSystem } from "../core/index.js";
import { realmPlugin } from "../../gurx/react.js";
import { system } from "../../gurx/realmFactory.js";
function patchMarkdownTransformers(transformers) {
  const transformersCopy = [...transformers];
  const codeTransformer = transformersCopy.find((t) => t === CODE);
  const codeTransformerCopy = {
    ...codeTransformer,
    dependencies: [CodeBlockNode],
    replace: (parentNode, _children, match) => {
      const codeBlockNode = $createCodeBlockNode({ code: "", language: match ? match[1] : "", meta: "" });
      parentNode.replace(codeBlockNode);
      setTimeout(() => codeBlockNode.select(), 80);
    }
  };
  transformersCopy.splice(transformersCopy.indexOf(codeTransformer), 1, codeTransformerCopy);
  return transformersCopy;
}
const [markdownShortcutPlugin] = realmPlugin({
  id: "markdown-shortcut",
  dependencies: ["lists", "headings", "codeblock", "quote"],
  systemSpec: system((_) => ({}), [coreSystem]),
  init: (realm) => {
    realm.pubKey("addComposerChild", () => /* @__PURE__ */ React__default.createElement(MarkdownShortcutPlugin, { transformers: patchMarkdownTransformers(TRANSFORMERS) }));
    realm.pubKey("addNestedEditorChild", () => /* @__PURE__ */ React__default.createElement(MarkdownShortcutPlugin, { transformers: patchMarkdownTransformers(TRANSFORMERS) }));
  }
});
export {
  markdownShortcutPlugin
};
